/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vp_Blocked_RedirectedInputs */



/**
* | output |
* | --- |
* | "Every seat is scored, but these victory points don't match any oust order." |
*
* @param {Vp_Blocked_RedirectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_redirected = /** @type {((inputs?: Vp_Blocked_RedirectedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_RedirectedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les placements sont notés, mais ces VP ne correspondent à aucun ordre d'éliminations.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los asientos tienen puntuación, pero estos VP no encajan con ningún orden de eliminaciones.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os assentos estão pontuados, mas estes VP não correspondem a nenhuma ordem de eliminações.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i posti sono valutati, ma questi VP non corrispondono a nessun ordine di eliminazioni.")
	return /** @type {LocalizedString} */ ("Every seat is scored, but these victory points don't match any oust order.")
});